import React from 'react';

import { AddButton, Text } from './styles';

export const LightBlueButton = ({ label, ...props }) => {
    return (
        <AddButton {...props}>
            <Text>{label}</Text>
        </AddButton>
    );
};
